// extracted by mini-css-extract-plugin
module.exports = {"backLink":"BackLink_backLink__2RI9O","backLinkIcon":"BackLink_backLinkIcon__3vab2"};